// URL path helpers for rivers. Zero data dependency — safe for client
// components. Uses state-index.ts (2.5KB) instead of rivers.ts (1.9MB).

import { getStateSlug } from '@/data/state-index'

function toSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/['']/g, '')
    .replace(/\s*—\s*/g, '-')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

export function getRiverSlug(river: { n: string }): string {
  let name = river.n
  if (!name.toLowerCase().includes('river') && !name.toLowerCase().includes('creek') && !name.toLowerCase().includes('fork')) {
    name = name + ' River'
  }
  return toSlug(name)
}

export function getRiverPath(river: { n: string; stateKey?: string; id: string }): string {
  const stateKey = river.stateKey || ''
  const stateSlug = getStateSlug(stateKey)
  const riverSlug = getRiverSlug(river)
  return `/rivers/${stateSlug}/${riverSlug}`
}
